import React, { Fragment, useEffect, useRef } from 'react'
import ScanSearchPanel, {
  ScanOption
} from '../../../components/_WMS/ScanSearchPanel/scanSearchPanel'
import { stockScanOptions } from './configuration/stockMobileOptions'
import { useStockSearch } from './Hooks/useStockSearch'
import { Modal } from '../../../components/_EOS/Modal'
import ModalSelection from './modalSelection'
import { StockStep } from './types/types'
import StockByPositionResults from './StockByPositionResults'
import StockBySkuResults from './StockBySkuResults'
import { Loading } from '../../../components/UI'
import { SnackBar } from '../../../components/SnackBar/Snackbar'
import { Box } from '@mui/material'

export const StockMobile = () => {
  const {
    activeStep,
    goToSearch,
    searchStock,
    refetchStockBySku,
    modalConfig,
    closeModal,
    handleSelectionChange,
    handleConfirm,
    stockData,
    searchContext,
    isLoading,
    isRefetching,
    snackbar,
    closeSnackbar
  } = useStockSearch()

  const handleSearch = (value: string, option: ScanOption) => {
    searchStock(value, option.key)
  }

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!snackbar.open) {
      inputRef.current?.focus()
    }
  }, [snackbar.open])

  return (
    <Fragment>
      <Box
        sx={{ width: '100%', maxWidth: { xs: '100%', md: '70%' }, mx: 'auto' }}
      >
        {/* ── Paso 0: Búsqueda ── */}
        {activeStep === StockStep.Search && (
          <>
            <ScanSearchPanel
              inputRef={inputRef}
              options={stockScanOptions}
              onSearch={handleSearch}
              hintLabel='Ingresa o escanea el dato'
              searchLabel='Buscar'
              disabled={isLoading}
            />
            {isLoading && <Loading />}
          </>
        )}

        {/* ── Paso 1: Resultados por ubicación ── */}
        {activeStep === StockStep.Results &&
          searchContext?.filterKey === 'location' &&
          stockData &&
          searchContext && (
            <StockByPositionResults
              data={stockData}
              context={searchContext}
              onBack={goToSearch}
            />
          )}

        {/* ── Paso 1b: Resultados por SKU ── */}
        {activeStep === StockStep.Results &&
          searchContext?.filterKey === 'sku' &&
          stockData &&
          searchContext && (
            <StockBySkuResults
              data={stockData}
              context={searchContext}
              onBack={goToSearch}
              onFilterChange={refetchStockBySku}
              isRefetching={isRefetching}
            />
          )}

        <Modal
          open={modalConfig.isOpen}
          title={modalConfig.title}
          onClose={closeModal}
          maxWidth='xs'
          successButton={{
            title: 'Confirmar',
            action: handleConfirm
          }}
          cancelButton={{
            title: 'Cancelar',
            action: closeModal
          }}
        >
          <ModalSelection
            description={
              <>
                <strong>{modalConfig.highlightedValue}</strong>{' '}
                {modalConfig.description}
              </>
            }
            options={modalConfig.options}
            onChange={handleSelectionChange}
          />
        </Modal>
        <SnackBar
          open={snackbar.open}
          setOpen={closeSnackbar}
          message={snackbar.message}
          status='error'
        />
      </Box>
    </Fragment>
  )
}
